import { render } from "./Stripe.vue?vue&type=template&id=28ffe10d&scoped=true"
import script from "./Stripe.vue?vue&type=script&lang=js"
export * from "./Stripe.vue?vue&type=script&lang=js"

import "./Stripe.vue?vue&type=style&index=0&id=28ffe10d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ffe10d"]])

export default __exports__